<div style="position: relative; height: 372px; width: 100%; margin: auto">
  <div *ngIf="isLoading" class="loading-chart">
    <ion-spinner></ion-spinner>
    <div>Loading chart data...</div>
  </div>

  <canvas
    *ngIf="!isLoading && !chartConfig.error"
    baseChart
    [type]="chartConfig.chartType"
    [datasets]="chartConfig.chartData.datasets"
    [labels]="chartConfig.chartData.labels"
    [options]="chartConfig.chartOptions"
  >
  </canvas>

  <div *ngIf="chartConfig.error" class="chart-error">
    {{ chartConfig.error }}
  </div>

  <div *ngIf="!savedReportId" class="no-chart-data">No chart data available</div>
</div>
